import { useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Flame, Play } from "lucide-react";
import { useContent } from "../lib/api";

export default function Workouts() {
  const { data: workouts, loading } = useContent("workouts");
  const [cat, setCat] = useState("All");
  const cats = ["All", ...Array.from(new Set(workouts.map((w) => w.category)))];
  const shown = cat === "All" ? workouts : workouts.filter((w) => w.category === cat);

  return (
    <div data-testid="workouts-page" className="px-4 md:px-8 pb-16 pt-2">
      <h1 className="font-display font-900 uppercase text-4xl md:text-5xl tracking-tight">Workout Library</h1>
      <p className="text-muted-foreground mt-1">Follow-along sessions for every goal, level and space.</p>
      <div className="flex flex-wrap gap-2 mt-6 mb-8">
        {cats.map((c) => (
          <button key={c} data-testid={`wcat-${c.toLowerCase().replace(/\s/g,'-')}`} onClick={() => setCat(c)}
            className={`px-4 py-2 rounded-full text-xs uppercase tracking-[0.1em] font-bold border transition-colors ${cat === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>{c}</button>
        ))}
      </div>
      {loading ? <p className="text-muted-foreground">Loading…</p> : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {shown.map((w) => (
            <Link key={w.id} to={`/app/workouts/${w.id}`} data-testid="workout-card" className="group border border-border rounded-xl overflow-hidden bg-card hover:border-primary transition-colors">
              <div className="relative aspect-video overflow-hidden">
                <img src={w.image} alt={w.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 grid place-items-center bg-black/25 group-hover:bg-black/10 transition-colors"><div className="grid place-items-center w-12 h-12 rounded-full bg-primary"><Play size={18} className="text-white fill-white" /></div></div>
                <span className="absolute top-3 left-3 text-[10px] uppercase tracking-wide font-bold bg-black/70 text-white px-2 py-1 rounded">{w.difficulty}</span>
              </div>
              <div className="p-4">
                <span className="text-[10px] uppercase tracking-[0.12em] text-primary font-bold">{w.category}</span>
                <h3 className="font-display font-700 uppercase text-xl tracking-tight leading-tight mt-1">{w.title}</h3>
                <div className="flex gap-4 text-xs text-muted-foreground mt-2"><span className="flex items-center gap-1"><Clock size={12} /> {w.duration}</span><span className="flex items-center gap-1"><Flame size={12} /> {w.calories} kcal</span></div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
